import { Link, useNavigate } from "react-router-dom";
import { Breadcrumb, Button, Modal } from 'react-bootstrap';
import { QuestionIcon } from '@primer/octicons-react';
import { useState, useRef, useEffect } from "react";
import QuestionModal from "./QuestionModal";
import { useQuiz } from "../QuizContext";

/* 지하실 비밀의 방 */
function Coffin() {
  const dialogEndRef = useRef(null);
  const [showModal, setShowModal] = useState(false);
  const { tabletSolved } = useQuiz();
  const [showBedModal, setShowBedModal] = useState(false);
  const [showPicModal, setShowPicModal] = useState(false);
  const [showSuitModal, setShowSuitModal] = useState(false);

  const [showBossButton, setShowBossButton] = useState(false);
  const [showBossModal, setShowBossModal] = useState(false);
  const [dialogIndex, setDialogIndex] = useState(0);

  useEffect(() => {
  if (dialogEndRef.current) {
    dialogEndRef.current.scrollIntoView({ behavior: 'smooth' });
  }
  }, [dialogIndex]);


  const dialogues = [
    { speaker: 'guild', text: '생각보다 빨리 왔네. 여기까지 들일 생각은 없었는데' },
    { speaker: 'player', text: '죄송합니다' },
    { speaker: 'guild', text: '됐어. 그래서, 김기려가 남긴 물건이란 게…' },
    { speaker: 'player', text: '김기려?' },
    { speaker: 'guild', text: '… 아무것도 아니야. 말해' },
    { speaker: 'player', text: '길드에 이 편지가 도착했는데, 이 편지를 꼭 길드장님께 전달해달라고 쓰여있었습니다' },
    { speaker: 'guild', text: '… (말없이 편지를 받아 든다. 그의 얼굴에서 어떤 감정도 느낄 수 없다. 마치 일부러 잠근 것처럼…)' },
    { speaker: 'player', text: '......' },
    { speaker: 'guild', text: '그럼 이만 나가주겠어?' },
    { speaker: 'player', text: '네, 실례했습니다' },
    { speaker: 'guild', text: '그래, 다음부터는 여기까지 내려오지 마시고. 이제는 사람 하나 치우는 것도 일이거든' },
    { speaker: 'player', text: '......' },
    { speaker: 'guild', text: '농담이야. 귀한 목숨 아껴드려야지' },
    { speaker: 'player', text: '......' },
    { speaker: 'guild', text: '그래도 오늘 본 건 그쪽만 알고 있는 게 좋을 거야' },
    { speaker: 'player', text: '... 네' },
    { speaker: 'guild', text: '아무튼... 고마워. 그만 가' },
  ];

  const [isLightOn, setIsLightOn] = useState(false); // 불 켜짐 여부
  const navigate = useNavigate();

  return (
    <div
      className="position-relative"
      style={{
        height: '100vh',
        backgroundColor: isLightOn ? 'white' : 'black',
        color: isLightOn ? 'black' : 'white',
        transition: 'background-color 1s, color 1s',
      }}
    >

      {/* Breadcrumb + 도움말 버튼 */}
      <div className="container pt-4">
        <div className="d-flex justify-content-between align-items-center">
          <Breadcrumb>
              <Breadcrumb.Item
                onClick={() => navigate('/inside/bedroom', { state: { fromCoffin: true } })}
              >
                  돌아가기
              </Breadcrumb.Item>
            <Breadcrumb.Item active style={{ color: isLightOn ? '' : 'white' }}>
              ???
            </Breadcrumb.Item>
          </Breadcrumb>

          <Button
            onClick={() => setShowModal(true)}
            variant={isLightOn ? "outline-primary" : "outline-light"}
            size="sm"
            style={{
              borderRadius: '50%',
              width: '40px',
              height: '40px',
              padding: '0',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              marginTop: '-12px'
            }}
          >
            <QuestionIcon size={24} />
          </Button>
        </div>
      </div>

      <QuestionModal show={showModal} handleClose={() => setShowModal(false)} />

      {/* 수평선 */}
      <div className="container">
        <hr className={`border ${isLightOn ? 'border-dark-subtle' : 'border-secondary'} border-2 opacity-100`} />
      </div>

      {/* 설명 */}
      <div className="container text-start" style={{ marginBottom: '10vh' }}>
        {isLightOn ? (
          <>
          <p>적막하다</p>
          <p>방 한가운데에 침대가 있고, 그 위에 정장 한 벌이 가지런히 놓여있다</p>
          <p>침대 옆 협탁에는 작은 액자가 있다</p>
          {showBossButton ? (
            <p>길드장님이 다가온다. 수척한 얼굴이다</p>
          ) : (
            <p></p>
          )}
          </>
        ) : (
          <>
          <p>적막하다</p> 
          <p>아무것도 보이지 않는다</p>
          </>
        )}
      </div>

      {/* 화면 중앙 버튼 */}
      <div
        className="d-grid gap-2 col-10 col-sm-6 col-md-4 col-lg-2 mx-auto"
        style={{
          position: 'absolute',
          top: '60%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
        }}
      >
        {isLightOn ? (
          <>
            <button className="btn btn-secondary" onClick={() => setShowBedModal(true)}>
              침대 살펴보기
            </button>

            <button className="btn btn-secondary" onClick={() => setShowPicModal(true)}>
              액자 살펴보기
            </button>
            <button className="btn btn-secondary" onClick={() => setShowSuitModal(true)}>
              정장 살펴보기
            </button>

            {showBossButton && (
            <button className="btn btn-secondary" onClick={() => setShowBossModal(true)}>
              길드장과 대화하기
            </button>
            )}
          </>
        ) : (
          <Button variant="light" onClick={() => setIsLightOn(true)}>
            불 켜기
          </Button>
        )}
      </div>

        <Modal
          show={showBedModal}
          onHide={() => setShowBedModal(false)}
          animation={true}
          centered={false}
          style={{
          position: 'fixed',
          bottom: '-100px',
          left: '0',
          right: '0',
          margin: '0vh',
          borderRadius: '12px 12px 0 0',
          }}
          >
        <Modal.Body className="text-center">
        <p>먼지 하나 없이 깨끗하다</p>
          
        </Modal.Body>
        <Modal.Footer className="justify-content-end" style={{ borderTop: 'none' }}>
          <Button variant="outline-primary" onClick={() => setShowBedModal(false)}>
          확인
          </Button>
        </Modal.Footer>
        </Modal>

         <Modal
          show={showPicModal}
          onHide={() => setShowPicModal(false)}
          animation={true}
          centered={false}
          style={{
          position: 'fixed',
          bottom: '-100px',
          left: '0',
          right: '0',
          margin: '0vh',
          borderRadius: '12px 12px 0 0',
          }}
          >
        <Modal.Body className="text-center">
        <p>한 남자의 독사진. 웃는 모습이 어색하다</p>
        <p>뿌리가 까만 금발머리라...   
          {tabletSolved ? ' 아까 태블릿에서 본 남자다' : ' 처음 보는 남자다'}
        </p>
        </Modal.Body>
        <Modal.Footer className="justify-content-end" style={{ borderTop: 'none' }}>
          <Button variant="outline-primary" onClick={() => setShowPicModal(false)}>
          확인
          </Button>
        </Modal.Footer>
        </Modal>

        {/* 정장 모달 */}
        <Modal
          show={showSuitModal}
          onHide={() => setShowSuitModal(false)}
          animation={true}
          centered={false}
          style={{
            position: 'fixed',
            bottom: '-100px',
            left: '0',
            right: '0',
            margin: '0vh',
            borderRadius: '12px 12px 0 0',
          }}
        >
          <Modal.Body className="text-center">
            <p>검은 정장. 낡고 헤졌다</p>
            <p>왼손이 있을 위치에 반지가 있다</p>
          </Modal.Body>
          <Modal.Footer className="justify-content-end" style={{ borderTop: 'none' }}>
            <Button
              variant="outline-primary"
              onClick={() => {
                setShowSuitModal(false);
                setShowBossButton(true); // 👈 길드장 버튼 표시
              }}
            >
              반지?
            </Button>
          </Modal.Footer>
        </Modal>
        
        <Modal
          show={showBossModal}
          onHide={() => setShowBossModal(false)}
          fullscreen="md-down" // 또는 style로 직접 높이 지정
          centered
          contentClassName="d-flex flex-column justify-content-between"
          style={{ height: '80vh' }}
        >
          <Modal.Body style={{ overflowY: 'auto', padding: '2rem' }}>
            {dialogues.slice(0, dialogIndex + 1).map((line, i) => (
              <p key={i} 
                  className={`mb-3 ${line.speaker === 'guild' ? 'text-start' : 'text-end'}`}
                  style={{ fontStyle: line.speaker === 'guild' ? 'italic' : 'normal' }}
                >
                  <strong>{line.speaker === 'guild' ? '길드장' : ''}</strong> {line.text}
              </p>
            ))}
              <div ref={dialogEndRef} />
          </Modal.Body>

          <Modal.Footer
            className="justify-content-end"
            style={{ borderTop: 'none', padding: '1rem 2rem' }}
          >
            {dialogIndex < dialogues.length - 1 ? (
              <Button
                className="d-flex justify-content-center align-items-center"
                variant="outline-secondary"
                onClick={() => setDialogIndex(prev => prev + 1)}
                style={{ width: '50px', height: '36px' }}
              >
                Enter
              </Button>
            ) : (
              <Link to="/ending"
              className="btn btn-outline-primary"
              onClick={() => setShowBossModal(false)}>사무실로 돌아가기</Link>
            )}
          </Modal.Footer>
        </Modal>

    </div>
  );
}

export default Coffin;
